'use client';
import { emitGTMEvent } from '@/features/gtm/shared/helper/emit-gtm-event';
import { CustomDataPayload } from '@/features/gtm/internal/types/gtm-datalayer';
import { useEffect } from 'react';
import { useCustomDataInitialized } from '@/features/gtm/shared/hooks/use-custom-data-initialized';

export const TrackPageView = ({ customData }: { customData: CustomDataPayload }) => {
  const customDataInitialized = useCustomDataInitialized();
  useEffect(() => {
    if (customDataInitialized) {
      emitGTMEvent('CUSTOM_DATA', customData);
      emitGTMEvent('VIRTUAL_PAGEVIEW', customData);
    }
  }, [customDataInitialized, customData]);

  return null;
};
